import { gx } from "@/components/gtax/base";
import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import { STANDARD, TIERS, monthlyAt, usd } from "./data";

const TierCard = ({ t }) => (
  <article className="gx-card gx-tier p-10 flex flex-col" data-testid={`gtax-tier-${t.id}`}>
    <div className="flex gap-1 text-[color:var(--gold2)]">
      {Array.from({ length: t.stars }).map((_, i) => <Star key={i} size={14} fill="currentColor" />)}
    </div>
    <img src={t.img} alt={`${t.name} mascot`} className="w-48 h-48 mx-auto my-8 object-contain" />
    <h3 className="gx-caps text-3xl">{t.name}</h3>
    <div className="mt-6 grid grid-cols-2 gap-y-4 text-sm">
      <span className="text-[color:var(--mute)]">Minimum deposit</span><span className="text-right" data-testid={`gtax-tier-${t.id}-min`}>{usd(t.min)}</span>
      <span className="text-[color:var(--mute)]">Annual licence</span><span className="text-right">{usd(t.licence)}</span>
      <span className="text-[color:var(--mute)]">Profit share</span><span className="text-right">{t.split}</span>
    </div>
    <div className="mt-8 pt-6 gx-line">
      <div className="text-xs tracking-widest uppercase text-[color:var(--mute)]">Illustration · 0.80% avg gross day, on the minimum</div>
      <div className="gx-serif text-4xl gx-gold mt-1" data-testid={`gtax-tier-${t.id}-monthly`}>{usd(t.min * monthlyAt(t, 0.8))}<span className="text-base text-[color:var(--mute)]"> / month</span></div>
    </div>
    <ul className="mt-8 space-y-3 text-sm text-[color:var(--ink)]/90 flex-1">
      {t.perks.map((p) => <li key={p} className="flex gap-3"><span className="text-[color:var(--gold)]">—</span>{p}</li>)}
    </ul>
    <Link to={gx(`/access?tier=${t.id}`)} className="gx-ghost mt-10 text-center" data-testid={`gtax-tier-${t.id}-cta`}>Request {t.name}</Link>
  </article>
);

export const GtaxTiers = () => (
  <section id="tiers" className="py-28 gx-line" data-testid="gtax-tiers">
    <div className="gx-wrap">
      <p className="gx-eyebrow">The Collection</p>
      <h2 className="gx-serif text-4xl md:text-5xl mt-6 max-w-2xl">Three tiers. One strategy. A larger share as you grow.</h2>
      <div className="mt-16 grid md:grid-cols-3 gap-6">{TIERS.map((t) => <TierCard key={t.id} t={t} />)}</div>
      <p className="mt-8 text-sm text-[color:var(--mute)]" data-testid="gtax-standard-note">
        Standard membership from {usd(STANDARD.min)}, no licence, 60/40 profit share. All figures are hypothetical illustrations
        net of all costs, payable only from realised profit, and are not guaranteed.
      </p>
    </div>
  </section>
);
